import React, { useState } from 'react';
// import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { AUTORIZACIONES_SOLICITUDES_ESTADOS } from '../../../../../utils/constants';

export const TableHeadSolicitudesProfesional = (props) => {

    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("calories");
    
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const fecha ={id: 'fechaEnviada', desc: 'Fecha Enviada'};

    const mostrarSeguimiento = parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO || 
    parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA ||
        parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
        parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA;

    const mostrarEfectorInstitucional = parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
      parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO;

    const mostrarEliminarSolicitud = parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA
    || parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE
    || parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION; 
    
    const mostrarPendientes = parseInt(props.estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA;

    const mostrarBandeja = parseInt(props.estadoSolicitudes) !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PRACTICAS_INTERNACION;

    const headCells = [
      { id: 'historial', align: "left", enabledSort: false, visible: true },
      { id: "idEstadoSolicitud", disablePadding: true, label: "Estado", align: "left", visible: true },
      { id: fecha.id, disablePadding: false, label: fecha.desc, align: "left", enabledSort: false, visible: true },
      { id: "idSolicitud", disablePadding: false, label: "N° Orden", align: "left", enabledSort: false, visible: true, maxWidth: 50 },
      { id: "idTipoSolicitud", disablePadding: false, label: "Tipo Solicitud", align: "left", enabledSort: false, visible: true },
      { id: "conInternacion", disablePadding: false, label: "Con Internación", align: "left", enabledSort: false, visible: true, maxWidth: 100 },
      { id: "diagnostico.problema", disablePadding: false, label: "Diagnostico", align: "left", enabledSort: false, visible: true },
      { id: "practicas", disablePadding: false, label: "Practicas", align: "left", enabledSort: false, visible: true },
      { id: "recupero", disablePadding: false, label: "Recupero", align: "left", enabledSort: false, visible: true },
      { id: "efectorGeneracion", disablePadding: false, label: "Medico Solicito", align: "left", enabledSort: false, visible: true },
      // { id: "afiliado", disablePadding: false, label: "Paciente", align: "left", enabledSort: false, visible: true },
      // { id: "nroAfiliado", disablePadding: false, label: "N° Afiliado", align: "left", enabledSort: false, visible: true },
      // { id: "idSeccional", disablePadding: false, label: "Seccional", align: "left", enabledSort: false, visible: true },
      { id: "efectorDenunciaInternacion", disablePadding: false, label: "Efector Institucional", align: "left", enabledSort: false, visible: mostrarEfectorInstitucional },
      { id: "tomada", disablePadding: false, label: "Tomada", align: "left", enabledSort: false, visible: true },
      { id: "pendiente", disablePadding: false, label: "Pendiente", align: "left", enabledSort: false, visible: mostrarPendientes },
      { id: "bandeja", disablePadding: false, label: "Bandeja", align: "left", enabledSort: false, visible: mostrarBandeja },
      { id: "estadiaAprob", disablePadding: false, label: "", align: "center", enabledSort: false, visible: true },
      { id: "eliminar", disablePadding: false, label: "Eliminar", align: "left", enabledSort: false, visible: mostrarEliminarSolicitud },
      { id: "seguimiento", disablePadding: false, label: "", align: "left", enabledSort: false, visible: mostrarSeguimiento },
      { id: 'btn', align: "left", enabledSort: false, visible: true },
    ];
  
    return (
      <TableHead>
        <TableRow>
          {headCells.filter(s => s.visible).map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{minWidth: headCell.minWidth, maxWidth: headCell.maxWidth}}
            >
              {headCell.enabledSort
                ?
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : "asc"}
                    onClick={handleRequestSort(headCell.id)}
                  >
                    {headCell.label}
                  </TableSortLabel>
                :
                  <>{headCell.label}</>
              }
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  TableHeadSolicitudesProfesional.propTypes = {
    // classes: PropTypes.object.isRequired,
    // onRequestSort: PropTypes.func.isRequired,
    // order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    // orderBy: PropTypes.string.isRequired,
  };